module.exports = __webpack_public_path__ + "static/media/avatar.bb820eb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.jpg
// module id = 277
// module chunks = 0